export default __webpack_public_path__ + "static/media/AppealVATTemplate.8329c580.xlsx";